"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HooksHelper = void 0;
const react_1 = require("react");
function useStateBuilder(initialState) {
    const [value, set] = react_1.useState(initialState);
    return { value, set };
}
exports.HooksHelper = {
    useStateBuilder
};
//# sourceMappingURL=Hooks.helper.js.map